import { render } from "./dataTableOthersPendingSign.vue?vue&type=template&id=0343dc9a&scoped=true&ts=true"
import script from "./dataTableOthersPendingSign.vue?vue&type=script&lang=ts"
export * from "./dataTableOthersPendingSign.vue?vue&type=script&lang=ts"

import "./dataTableOthersPendingSign.vue?vue&type=style&index=0&id=0343dc9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0343dc9a"]])

export default __exports__